module.exports = __webpack_public_path__ + "img/search.1425e307.png";